import { render, staticRenderFns } from "./sellers-v2.page.vue?vue&type=template&id=7562c515&scoped=true"
import script from "./sellers-v2.page.vue?vue&type=script&lang=js"
export * from "./sellers-v2.page.vue?vue&type=script&lang=js"
import style0 from "./sellers-v2.page.vue?vue&type=style&index=0&id=7562c515&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7562c515",
  null
  
)

export default component.exports